var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-451.886,-311.053)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.55219,0,0,1.55219,-250.63,-187.188)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.886,
    y: 322.281,
    width: 38.655,
    height: 38.655,
    style: {
      fill: "none",
      stroke: "rgb(38,166,154)",
      strokeWidth: "2.58px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2,0,0,1.2,-90.7772,-73.6843)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.886,
    y: 322.281,
    width: 50,
    height: 10.048,
    style: {
      fill: "rgb(38,166,154)",
      stroke: "rgb(38,166,154)",
      strokeWidth: "3.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.67838e-17,0.600725,-0.600725,3.67838e-17,695.525,64.4214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.862,332.329L493.838,372.281L453.886,372.281L473.862,332.329Z",
    style: {
      fill: "none",
      stroke: "rgb(38,166,154)",
      strokeWidth: "6.66px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/PlayVideo.c8e7155455a9beda5d8c565b66b495c9.svg";
export { ForwardRef as ReactComponent };